module.exports = __webpack_public_path__ + "media/images/riders/small/SAMUEL_BLEKINSOP-fbe1672b02f1d5f65b15a0464589ec8a.png";